import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Button } from "../ui/button";
import { List, Plus } from "@phosphor-icons/react";
import { useAuth } from "../../contexts/AuthContext";
import NotificationBell from "../NotificationBell";

export default function Layout() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="flex min-h-screen bg-background text-foreground">
            <Sidebar
                collapsed={collapsed}
                onToggle={() => setCollapsed((c) => !c)}
                mobileOpen={mobileOpen}
                onMobileClose={() => setMobileOpen(false)}
            />
            <div className="flex-1 min-w-0 flex flex-col">
                <header className="lg:hidden sticky top-0 z-20 flex items-center justify-between px-4 py-3 border-b border-border bg-card/80 backdrop-blur-md">
                    <button
                        onClick={() => setMobileOpen(true)}
                        className="p-2 rounded-md hover:bg-black/5 dark:hover:bg-white/5"
                        data-testid="mobile-menu-button"
                        aria-label="Open menu"
                    >
                        <List size={22} />
                    </button>
                    <div className="font-display font-black text-base tracking-tight">
                        <span className="text-[#6C63FF]">Ideas</span><span className="text-[#FF8A00]">Mine</span>
                    </div>
                    {user ? (
                        <>
                            <NotificationBell />
                            <Button
                                size="sm"
                                onClick={() => navigate("/create")}
                                className="brand-button"
                                data-testid="mobile-create-button"
                            >
                                <Plus size={16} weight="bold" />
                            </Button>
                        </>
                    ) : (
                        <Button
                            size="sm"
                            onClick={() => navigate("/auth")}
                            className="brand-button"
                            data-testid="mobile-signin-button"
                        >
                            Sign in
                        </Button>
                    )}
                </header>
                <main className="flex-1 min-w-0">
                    <Outlet />
                </main>
                {user && (
                    <button
                        onClick={() => navigate("/create")}
                        className="lg:hidden fixed bottom-6 right-6 brand-button rounded-full h-14 w-14 grid place-items-center shadow-2xl z-30"
                        data-testid="fab-create"
                        aria-label="Create idea"
                    >
                        <Plus size={26} weight="bold" />
                    </button>
                )}
            </div>
        </div>
    );
}
